import { createUnarySpacing as e } from "./index37.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/createTheme/createSpacing.js
function t(t = 8, n = e({ spacing: t })) {
	if (t.mui) return t;
	let r = (...e) => (process.env.NODE_ENV !== "production" && (e.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${e.length}`)), (e.length === 0 ? [1] : e).map((e) => {
		let t = n(e);
		return typeof t == "number" ? `${t}px` : t;
	}).join(" "));
	return r.mui = !0, r;
}
//#endregion
export { t as default };

//# sourceMappingURL=index38.js.map